module.exports = __webpack_public_path__ + "static/media/IMG_6908_2.3b9a2b2e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/photos/IMG_6908_2.jpg
// module id = 218
// module chunks = 0